module.exports = __webpack_public_path__ + "media/new_message2.00036105.ogg";